exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".vca-alerts-module {\n  width: 100%;\n  position: relative; }\n\n.vca-alerts-overlay {\n  position: absolute;\n  width: 100%;\n  top: 0;\n  left: 0;\n  z-index: 999; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/common/vca-alerts/vca-alerts.scss
// module id = BMu2
// module chunks = 0